<template>
  <div>
    <label class="text-uppercase text-muted font-weight-bold small">Vast Publisher Integration</label>
    <b-alert show>
      The below VAST tag is geo-routed. Fill in the idfa parameter with the device ID if applicable.
    </b-alert>
    <code>
      <b-form-textarea
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        readonly
        class="squared-textarea bg-white" rows="2"
        :value="ENDPOINT_GLOBAL_SSL + '/publisher/vast?zoneid=' + zone.id + macroString">
      </b-form-textarea>
    </code>
    <b-card title="Macros" class="mt-4">
      <b-alert show>
        If the tag is used for more than one placement, please fill out all macros possible and set &universal=true
      </b-alert>
      <b-row v-for="macro in macroMap" :key="macro.label">
        <b-col lg="4">
          <b-badge variant="primary">
            {{ macro.label }}
          </b-badge>
        </b-col>
        <b-col>
          {{ macro.description }}
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
    export default {
        name: 'IntegrationVast',
        data () {
          return {
            ENDPOINT_GLOBAL_SSL,
            macros: {
              ua: 'Device user agent',
              idfa: 'Device ID (GAID or IDFA)',
              maxduration: 'Max video duration',
              name: 'App or site name',
              bundle: 'App bundle',
              skippable: 'true/false or 0/1, if ad is skippable',
              publisher: 'Name of publisher',
              w: 'Player width',
              h: 'Player height',
              gdpr: '0 or 1 if gdpr applies',
              gdprcs: 'GDPR Consent string if available',
              ozoneid: 'Override the zone id (tagid value)',
              universal: 'true/false if this tag is RON'
            }
          }
        },
        computed: {
          macroString () {
            let m = ''
            for (let key in this.macros) {
              m += '&' + key + '='
            }

            return m
          },
          macroMap () {
            let map = []

            for (let key in this.macros) {
              map.push({
                label: key,
                description: this.macros[key]
              })
            }

            return map
          }
        },
        props: {
            zone: { required: true, type: Object }
        }
    }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/Integrations/Vast.vue